import styled, { css } from "styled-components";
import type { SlideStyledProps } from "../types";

export const SlideStyled = styled.div<SlideStyledProps>`
  justify-content: ${({ $verticalAlignment }) =>
    $verticalAlignment || "inherit"};
  align-items: ${({ $horizontalAlignment }) =>
    $horizontalAlignment || "inherit"};

  ${({ $minHeight }) => $minHeight === "narrow" && slideNarrow};
`;

const slideNarrow = css`
  padding: var(--slide-padding-narrow-y) var(--slide-padding-narrow-x) !important;
  @media screen and (max-width: 768px) {
    padding: var(--mobile-slide-padding-narrow-y)
      var(--mobile-slide-padding-narrow-x) !important;
  }
`;

const MIN_HEIGHT_ZERO = 0;
const MIN_HEIGHT_SCREEN_FIT =
  "calc(var(--sd-max-vh, 100vh) - var(--slide-padding-y) * 2)";
const MIN_HEIGHT_SCREEN_FIT_EDITOR =
  "calc((var(--sd-max-vh, 100vh) - var(--slide-padding-y) * 2) - var(--screen-fit-height-offset))";

export const SlideWrapper = styled.div<{
  $minHeight: string;
  $editor: boolean;
}>`
  ${({ $minHeight = "auto", $editor = false }) => {
    switch ($minHeight) {
      case "narrow":
      case "auto":
        return css`
          min-height: ${MIN_HEIGHT_ZERO};
        `;
      case "screenFit":
        if ($editor) {
          return css`
            min-height: ${MIN_HEIGHT_SCREEN_FIT_EDITOR};
          `;
        } else {
          return css`
            min-height: ${MIN_HEIGHT_SCREEN_FIT};
          `;
        }
      default:
        return null;
    }
  }};
`;
